<template>
  <div class="card flex justify-center">
    <Toast position="bottom-right" group="br" />
  </div>
</template>

<script setup lang="ts">
import Toast from "primevue/toast";
import { onMounted, ref } from "vue";
import { useNotificationsApi } from "@/core/composables/useNotificationsApi";
import { useAlerts } from "@/shared/composables/useAlerts";

// component

const { infoToast } = useAlerts();

// types
// props
// context
// emit
// api

const { fetchNotifications, activeNotification } = useNotificationsApi();

// state

const notificationText = ref("");

// computed

// methods
// event handlers

const showBottomRight = () => {
  infoToast("Notification", notificationText.value, { group: "br", life: 0 });
};

// watchers
// lifecycle

onMounted(async () => {
  await fetchNotifications({ active: true });

  notificationText.value = activeNotification.value.text;

  if (activeNotification.value !== null && Object.keys(activeNotification.value).length !== 0)
    showBottomRight();
});
</script>
